import {
  IConvertedArticleContent,
  ISourceArticleElement,
} from "../learningCenter/interfaces";

export function convertToArticleContent(
  sourceData: ISourceArticleElement[]
): IConvertedArticleContent[] {
  const result: IConvertedArticleContent[] = [];
  let currentChapter: IConvertedArticleContent | null = null;
  let chapterIndex = 0;

  for (let i = 0; i < sourceData.length; i++) {
    const element = sourceData[i];

    if (element.type === "heading") {
      const elementText = element.children
        .map((child) => child.text)
        .join("")
        .trim();

      if (!elementText) {
        continue;
      }

      if (currentChapter) {
        result.push(currentChapter);
      }

      chapterIndex++;
      currentChapter = {
        id: `chapter${chapterIndex}`,
        title: elementText,
        content: [],
      };
    } else if (element.type === "paragraph") {
      const elementText = element.children
        .map((child) => child.text)
        .join("")
        .trim();

      if (!elementText) {
        continue;
      }

      if (!currentChapter) {
        chapterIndex++;
        currentChapter = {
          id: `chapter${chapterIndex}`,
          title: ``,
          content: [],
        };
      }

      currentChapter.content.push({
        type: "paragraph",
        content: [elementText],
      });
    } else if (element.type === "list") {
      if (!currentChapter) {
        chapterIndex++;
        currentChapter = {
          id: `chapter${chapterIndex}`,
          title: ``,
          content: [],
        };
      }

      const listType = element.format || "unordered";
      const listItems = element.children
        .filter((child) => child.type === "list-item")
        .map((child: any) => {
          return child.children
            .map((item: any) => item.text)
            .join("")
            .trim();
        })
        .filter((text) => text);

      if (listItems.length === 0) {
        continue;
      }

      currentChapter.content.push({
        type: `${listType}-list`,
        content: listItems,
      });
    }
  }

  if (currentChapter) {
    result.push(currentChapter);
  }

  return result;
}
